'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ReviewReply = require('./ReviewReply.scss');

var _ReviewReply2 = _interopRequireDefault(_ReviewReply);

var _media = require('utils/media');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  ReviewReply: {
    displayName: 'ReviewReply'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/ReviewReply.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var ReviewReply = _wrapComponent('ReviewReply')((_dec = (0, _reactCssModules2.default)(_ReviewReply2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReviewReply, _Component);

  function ReviewReply() {
    (0, _classCallCheck3.default)(this, ReviewReply);
    return (0, _possibleConstructorReturn3.default)(this, (ReviewReply.__proto__ || (0, _getPrototypeOf2.default)(ReviewReply)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReviewReply, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          reply = _props.reply,
          replier = _props.replier;

      var defaultImage = require('theme/images/default-img.png');
      return _react3.default.createElement(
        'div',
        { styleName: 'reply-container' },
        _react3.default.createElement(
          'div',
          { styleName: 'replier' },
          _react3.default.createElement(
            'div',
            { styleName: 'replier-pic' },
            _react3.default.createElement('img', { src: replier && replier.avatar_image ? (0, _media.path)(replier.avatar_image, 'profileAvatar') : defaultImage, alt: replier && replier.name && replier.name.first + ' ' + replier.name.last })
          ),
          _react3.default.createElement(
            'span',
            { className: 'replier-user-name', styleName: 'replier-user-name' },
            replier && replier.name && '' + replier.name.first
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'reply-content' },
          _react3.default.createElement(
            'p',
            null,
            reply.text.split('\n').map(function (line, index) {
              if (index + 1 < reply.text.split('\n').length) {
                return [_react3.default.createElement(
                  'span',
                  { key: 'text-' + index },
                  line
                ), _react3.default.createElement('br', { key: 'break-' + index })];
              }
              return _react3.default.createElement(
                'span',
                { key: 'text-' + index },
                line
              );
            })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'date' },
            _react3.default.createElement(
              'span',
              null,
              (0, _momentTimezone2.default)(reply.created_at).format('MMMM DD, YYYY')
            )
          )
        )
      );
    }
  }]);
  return ReviewReply;
}(_react2.Component), _class2.propTypes = {
  reply: _react2.PropTypes.object,
  replier: _react2.PropTypes.object
}, _class2.defaultProps = {
  reply: {}
}, _temp)) || _class));

exports.default = ReviewReply;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/ReviewReply.js
// module id = 263
// module chunks = 0 2 9